import React from 'react';
import { useCarNameLabel } from '../../../../utils/carNames';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ImageGallery from 'react-image-gallery';
import $, { map } from 'jquery';
import { DETAIL_LIST } from '../../../../Redux/Actions/ActionType';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'bootstrap/dist/css/bootstrap.css';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { saveAItem, removeSavedItem, getSavedItems } from '../../../../Redux/Actions/UserAction';
import Swal from 'sweetalert2';
import { shareItem } from '../../../../utils/shareItem';
import { externalUrl } from "../../../../utils/externalUrl";
import { formatRentalPeriod } from './RentCarDetailsIn';
import { buildSavedIdSet, findSavedItemId } from '../../../../utils/savedItems';

import 'react-image-gallery/styles/css/image-gallery.css';
import { useTranslation } from 'react-i18next';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const defaultImages = [
  {
    original: 'assets/images/service-provider/rent-car/banner.jpg',
  },
];

const openStatus = ['OPEN', 'مفتوح'];

export default function RentCarDetails() {
  const { t, i18n } = useTranslation();
  /* [CF 2026-08-17 #11.1] Model is free text with no Arabic on the row; look it
     up from the model master. See utils/carNames.js */
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const nameLabel = useCarNameLabel(isRTL);
  var home = useSelector((state) => state.home);
  const DetailList = home?.getDetailList?.[0];
  const dispatch = useDispatch();
  const { carRentId } = useParams();
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [lightboxIdx, setLightboxIdx] = useState(null);

  const savedItemsList = useSelector((state) => state?.home?.savedItemsList);
  const savedIdSet = buildSavedIdSet(savedItemsList);
  const [savedOverride, setSavedOverride] = useState({});
  const isSaved = (id) =>
    savedOverride[id] !== undefined ? savedOverride[id] : savedIdSet.has(String(id));

  const onHandleSave = (carId) => {
    // Check if user is logged in
    const isLoggedIn = sessionStorage.getItem('loged_In') === 'true';
    
    if (!isLoggedIn) {
      Swal.fire({
        title: 'Please Login to Save',
        text: 'You need to be logged in to save this car. Please login first.',
        icon: 'warning',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Login',
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to login page
          window.location.href = '#/login';
        }
      });
      return;
    }

    // User is logged in — optimistic toggle, no reload.
    const currentlySaved = isSaved(carId);
    setSavedOverride((prev) => ({ ...prev, [carId]: !currentlySaved }));
    if (currentlySaved) {
      const savedItemId = findSavedItemId(savedItemsList, carId);
      if (savedItemId) dispatch(removeSavedItem({ savedItemId }));
    } else {
      dispatch(saveAItem({ carRentalId: carId }));
    }
  };

  useEffect(() => {
    dispatch(getSavedItems());
  }, [dispatch]);

  useEffect(() => {
    const fetchDetail = async (data) => {
      var object = { carRentId };
      let query = '';
      Object.keys(object).forEach((key) => {
        console.log('this is object key', key);
        query += key + '=' + object[key] + '&';
      });
      query = query.slice(0, -1);
      console.log('this is the,', query);
      try {
        axios

          .get(
            `https://api.carsavenue.com/api/carRent/listing` +
              '?' +
              query,

            config
          )

          .then((res) => {
            console.log('heeee<<<<', res);
            dispatch({
              type: DETAIL_LIST,
              payload: res.data.response?.data,
            });

            console.log('heeee<<<<', res);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {}
    };
    if (carRentId && carRentId !== '') fetchDetail({ carRentId });
  }, [carRentId, dispatch]);

  if (!DetailList) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  console.log('DetailList', DetailList);

  //Business Media Data, LOGO, BANNER
  const logoData = DetailList?.businessMedia?.find(
    (item) => item.mediaType === 'LOGO'
  );

  let bannerImages = defaultImages;

  if (DetailList?.businessMedia && DetailList.businessMedia.length > 0) {
    const mediaImages = DetailList.businessMedia
      .filter(
        (mediaItem) =>
          mediaItem?.media?.path &&
          (mediaItem.mediaType === 'MAIN_BANNER' ||
            mediaItem.mediaType === 'BANNER')
      )
      .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      bannerImages = mediaImages;
    }
  }

  // Banner renderer: fixed-height banner that shows the WHOLE uploaded image
  // (no cropping) centered, with a blurred copy filling the empty space — so
  // both wide strips and square ad-posters look consistent and intentional.
  const fallbackBanner = 'assets/images/service-provider/rent-car/banner.jpg';

  //Business Calendar
  let businessCalendar = {};
  try {
    businessCalendar =
      (typeof DetailList?.calendar === 'string'
        ? JSON.parse(DetailList?.calendar)
        : DetailList?.calendar) || {};
  } catch (e) {
    businessCalendar = {};
  }
  const now = new Date();
  const currentDay = now
    .toLocaleString('en-us', { weekday: 'long' })
    .toUpperCase(); // "MONDAY"

  const currentTime = now.getHours() * 60 + now.getMinutes();

  const timeToMinutes = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours < 12) hours += 12;
    if (period === 'AM' && hours === 12) hours -= 12;
    return hours * 60 + minutes;
  };

  let isOpen = false;
  let nextActionTime = ''; // Time for the next action

  const todaySchedule = (businessCalendar || {})[currentDay];

  if (todaySchedule) {
    const { status, openTime, endTime } = todaySchedule;

    if (status === 'مفتوح' || status === 'OPEN') {
      // "Open" status
      const openMinutes = timeToMinutes(openTime);
      const closeMinutes = timeToMinutes(endTime);

      if (currentTime >= openMinutes && currentTime <= closeMinutes) {
        isOpen = true;
        nextActionTime = endTime; // Display closing time
      } else if (currentTime < openMinutes) {
        isOpen = false;
        nextActionTime = openTime; // Display opening time
      } else {
        isOpen = false;
        nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display next day's opening time if closed
      }
    } else {
      isOpen = false;
      nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display opening time if closed
    }
  }

  //Location Data
  let gpsData = {};
  try {
    gpsData =
      (typeof DetailList?.gps === 'string'
        ? JSON.parse(DetailList?.gps)
        : DetailList?.gps) || {};
  } catch (e) {
    gpsData = {};
  }
  const lat = parseFloat((gpsData || {}).lat);
  const lng = parseFloat((gpsData || {}).long);

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  //Social Media Data
  let socialMediaData = {};
  try {
    socialMediaData =
      (typeof DetailList?.socialMedia === 'string'
        ? JSON.parse(DetailList?.socialMedia)
        : DetailList?.socialMedia) || {};
  } catch (e) {
    socialMediaData = {};
  }

  return (
    <div>
      {lightboxIdx !== null && bannerImages[lightboxIdx] && (
        <div className="cav-lightbox" onClick={() => setLightboxIdx(null)}>
          <button
            className="cav-lb-close"
            aria-label="Close"
            onClick={() => setLightboxIdx(null)}
          >
            &times;
          </button>
          {bannerImages.length > 1 && (
            <button
              className="cav-lb-prev"
              aria-label="Previous"
              onClick={(e) => {
                e.stopPropagation();
                setLightboxIdx(
                  (lightboxIdx - 1 + bannerImages.length) % bannerImages.length
                );
              }}
            >
              &#8249;
            </button>
          )}
          <img
            src={bannerImages[lightboxIdx].original}
            alt=""
            onClick={(e) => e.stopPropagation()}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = fallbackBanner;
            }}
          />
          {bannerImages.length > 1 && (
            <button
              className="cav-lb-next"
              aria-label="Next"
              onClick={(e) => {
                e.stopPropagation();
                setLightboxIdx((lightboxIdx + 1) % bannerImages.length);
              }}
            >
              &#8250;
            </button>
          )}
          {bannerImages.length > 1 && (
            <div className="cav-lb-count">
              {lightboxIdx + 1} / {bannerImages.length}
            </div>
          )}
        </div>
      )}
      <div class="user-banner">
        <div className="container cav-gallery-wrap">
        <div
          className={`cav-gallery ${
            bannerImages.length === 1
              ? 'cav-gallery--1'
              : bannerImages.length === 2
                ? 'cav-gallery--2'
                : bannerImages.length === 3
                  ? 'cav-gallery--3'
                  : 'cav-gallery--many'
          }`}
        >
          {bannerImages.map((item, i) => (
            <div
              className="cav-gallery-cell"
              key={i}
              onClick={() => setLightboxIdx(i)}
            >
              <img
                src={item.original}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = fallbackBanner;
                }}
              />
              {bannerImages.length > 5 && i === 4 && (
                <div className="cav-gallery-more">
                  <span>+{bannerImages.length - 5}</span>
                  <span>See all {bannerImages.length} photos</span>
                </div>
              )}
            </div>
          ))}
        </div>
        </div>

        <div class="user-logo-holder">
          <div class="container">
            <div class="user-logo-holder-wrap">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div class="row align-items-center">
                    <img
                      src={logoData?.media?.path || ''}
                      alt=""
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          'assets/images/service-provider/rent-car/logo.jpg';
                      }}
                      className="max-w-2 max-h-2 rounded-full"
                      style={{
                        width: '140px',
                        height: '140px',
                        objectFit: 'contain',
                        backgroundColor: '#fff',
                      }}
                    />
                    <div class="col-8 col-sm-8 col-md-auto">
                      <h5 class="mb-3">{DetailList?.carRentName}</h5>
                      <ul class="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <a
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <a
                            target="_blank"
                            href={`https://wa.me/${`${DetailList?.whatsAppNumberCountryCode}${DetailList?.whatsAppNumber}`.replace(/\D/g, '')}`}
                          >
                            <i class="fab fa-whatsapp"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          <CallLink
                            target="_blank"
                            record={DetailList}
                          >
                            <i class="fas fa-phone"></i>
                          </CallLink>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a href="javascript:void(0);" onClick={handleOpenMap}>
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <MapModalForView
                            open={mapModalOpen}
                            handleClose={handleCloseMap}
                            currentLocation={{
                              lat: lat,
                              long: lng,
                            }}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-auto">
                  {(isOpen || (nextActionTime && `${nextActionTime}`.trim() !== '')) && (
                    <p class="mb-3">
                    <span class={isOpen ? 'open-time' : 'close-time'}>
                      {isOpen ? t('Open Now') : t('Close Now')}
                    </span>{' '}
                    |{' '}
                    <span class={isOpen ? 'close-time' : 'open-time'}>
                      {isOpen
                        ? `${t('Closes at')} ${nextActionTime}`
                        : `${t('Open at')} ${nextActionTime}`}
                    </span>
                  </p>
                  )}
                  <ul className="list-inline mb-0">
                    {DetailList?.website && (
                      <li className="list-inline-item">
                        <a
                          href={externalUrl(DetailList?.website)}
                          target="_blank"
                          rel="noreferrer"
                          title="Website"
                        >
                          <i
                            className="fas fa-globe"
                            style={{ fontSize: '24px', color: '#0e76a8', verticalAlign: 'middle' }}
                          ></i>
                        </a>
                      </li>
                    )}
                    {socialMediaData?.INSTAGRAM && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.INSTAGRAM)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/instagram.png"
                            alt="Instagram"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.FACEBOOK && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.FACEBOOK)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/facebook.png"
                            alt="Facebook"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.TWITTER && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.TWITTER)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/twitter.png"
                            alt="Twitter"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.LINKEDIN && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.LINKEDIN)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/linkedin.png"
                            alt="Linkedin"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.YOUTUBE && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.YOUTUBE)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/youtube.png"
                            alt="Youtube"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.SNAPCHAT && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.SNAPCHAT)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/snapchat.png"
                            alt="Snapchat"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.GOOGLEPLUS && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.GOOGLEPLUS)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/google-plus.png"
                            alt="Google Plus"
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              {/* Calendar Modal */}
              <div
                class="modal fade"
                id="calendar-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{t('Timing')}</h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table table-bordered table-striped">
                        <tbody>
                          <tr>
                            <td scope="col">{t('Day')}</td>
                            <td scope="col">{t('Open')}</td>
                            <td scope="col">{t('Close')}</td>
                          </tr>
                          {[
                            'SUNDAY',
                            'MONDAY',
                            'TUESDAY',
                            'WEDNESDAY',
                            'THURSDAY',
                            'FRIDAY',
                            'SATURDAY',
                          ].map((day) => {
                            const status = openStatus.includes(
                              businessCalendar?.[day]?.status
                            );

                            return status ? (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.openTime}
                                </td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.endTime}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">{t('Closed')}</td>
                                <td scope="col">{t('Closed')}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-content-area">
        <div class="container">
          <h5 className="cav-section-title">{t('About Us')}</h5>
          {DetailList?.about?.split('\n').map((line, index) => (
            <p key={index}>{line}</p>
          ))}

          <h5 className="cav-section-title">{t('Cars')}</h5>

          <div class="row">
            {DetailList?.car !== undefined ? (
              DetailList?.car.map((item, i) => {
                const carImageFirst = item?.carMedia?.[0]?.media?.path;
                // [CF-14] Lowest-priced package for the "Starting From" label.
                // Keep the matching package so we can also show its rental
                // period (day count) alongside the price.
                const cheapestPkg = (item?.packages || [])
                  .filter((p) => !isNaN(parseFloat(p?.starting_price)))
                  .reduce(
                    (min, p) =>
                      min == null ||
                      parseFloat(p.starting_price) <
                        parseFloat(min.starting_price)
                        ? p
                        : min,
                    null
                  );
                const startFrom =
                  cheapestPkg != null
                    ? parseFloat(cheapestPkg.starting_price)
                    : null;
                // Use the same formatter as the detail page so "1/day" renders
                // cleanly as "1 Day" — and localized ("1 يوم" in Arabic).
                const startFromDays = formatRentalPeriod(
                  cheapestPkg?.time,
                  t('Day')
                );
                return (
                  <>
                    <div class="col-6 col-sm-6 col-md-4 col-lg-3 mb-4">
                      <div class="user-car-dealers-wrap">
                        <div class="line-a">
                          <Link
                            // to='/user-rent-car-details-in'
                            to={`/user-rent-car-details-in/${item?.carId}`}
                          >
                            <img
                              src={
                                carImageFirst ||
                                'assets/images/user/car-dealers/a.jpg'
                              }
                              alt=""
                              class="img-fluid"
                            />
                          </Link>
                        </div>
                        <div class="line-b">
                          {/* Brand + Save/Share — one aligned row */}
                          <div className="cav-card-row">
                            <div class="line-ba">{nameLabel(item?.carName)}</div>
                            <div className="cav-card-actions">
                              <button
                                onClick={() => onHandleSave(item?.carId)}
                                title="Save"
                                class="ss-btn"
                                style={{ cursor: 'pointer', background: 'none', border: 'none', color: isSaved(item?.carId) ? '#FFC400' : 'inherit', padding: 0, fontSize: 'inherit' }}
                              >
                                <i class={isSaved(item?.carId) ? 'fas fa-heart' : 'far fa-heart'}></i>
                              </button>
                              <a
                                href="#"
                                onClick={(e) =>
                                  shareItem(e, `/user-rent-car-details-in/${item?.carId}`, item?.carName)
                                }
                                title="Share"
                                class="ss-btn"
                              >
                                <i class="far fa-share-square"></i>
                              </a>
                            </div>
                          </div>
                          {/* Model + year — aligned to the same two columns */}
                          <div className="cav-card-row line-bb">
                            <span>{nameLabel(item?.carModel)}</span>
                            <span>{item?.modelYear?.modelYear}</span>
                          </div>
                        </div>
                        {/* [CF-14] Starting-from rental price */}
                        <div class="line-c">
                          {startFrom != null ? (
                            <span>
                              {`${t('Starting From')} ${t('KD')} ${startFrom}`}
                              {startFromDays ? ` / ${startFromDays}` : ''}
                            </span>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })
            ) : (
              <div
                className="text-center text-warning"
                const
                style={{
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <PageLoader /> <br />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
